import React, { useCallback, useContext, useMemo } from 'react';

import { Modal } from 'antd';

// REDUX
import { useSelector } from 'react-redux';

import { ApplicationState } from 'store';
import { IConsultaPesquisaCriminal } from 'store/modules/api/iirgd/consultaPesquisaCriminal/types';

// SERVICE
import { postApi } from 'services/rotasp/api';
import { PATH_IIRGD_BU_PPT } from 'services/rotasp/path';

// STYLED
import { AuthContext, IAuthContext } from 'react-oauth2-code-pkce';
import { removeCamposNulos } from 'utils/genericFunctions';
import { Button } from './styled';

interface Props {
	data: IConsultaPesquisaCriminal;
	onSuccess: () => void;
}

export const CentralLiberacao: React.FC<Props> = ({ data, onSuccess }) => {
	const { token } = useContext<IAuthContext>(AuthContext);
	const { login } = useSelector(
		(state: ApplicationState) => state.api.sgu.loginUnico,
	);

	const { consultaPesquisaCidadao } = useSelector(
		(state: ApplicationState) => state.api.iirgd,
	);

	const body = useMemo(
		() => ({
			envioPosto: login.user.posto,
			pesquisaDtNascimento:
				consultaPesquisaCidadao?.selecionado?.dataNascimento,
			pesquisaMae: consultaPesquisaCidadao?.selecionado?.nomeMae,
			pesquisaNome: consultaPesquisaCidadao?.selecionado?.nome,
			pesquisaPai: consultaPesquisaCidadao?.selecionado?.nomePai,
			pesquisaRg: consultaPesquisaCidadao?.selecionado?.numeroRg,
			restricaoDtNascimento: data.dataNascimento,
			restricaoMae: data.nomeMae,
			restricaoNaturalidade: data.descricaoNaturalidade,
			restricaoNome: data.nome,
			restricaoObservacao: data.status,
			restricaoPai: data.nomePai,
			restricaoRg: data.numeroRg,
			restricaoStatusEmissao: data.statusEmissao,
		}),
		[login, consultaPesquisaCidadao, data],
	);

	const headers = useMemo(
		() => ({
			usuario: login.mainframe.idUsuario,
		}),
		[login],
	);

	const handleSubmit = useCallback(async () => {
		if (consultaPesquisaCidadao.selecionado) {
			const response = await postApi(
				token,
				PATH_IIRGD_BU_PPT,
				'criminal/central-liberacao',
				removeCamposNulos(body),
				headers,
			);

			if (response.status === 200) {
				onSuccess();
			}
		}
	}, [consultaPesquisaCidadao.selecionado, onSuccess, token, body, headers]);

	const handleClick = useCallback(() => {
		const envioCentralLiberacao = login.user.parametrosLocalidade.find(
			parametro => parametro.sigla === 'HABILITA_ENVIO_CENTRAL_LIBERACAO',
		);

		if (envioCentralLiberacao && envioCentralLiberacao.valor === 'TRUE') {
			Modal.confirm({
				title: 'Enviar para Central de Liberação?',
				content: (
					<>
						<div>{data.nome}</div>
						<div>RGE/CIN: {data.numeroRg}</div>
					</>
				),
				onOk() {
					handleSubmit();
				},
				cancelText: 'Cancelar',
				okText: 'Enviar',
				style: { animationDuration: '0s' },
			});
		}
	}, [login.user.parametrosLocalidade, data, handleSubmit]);

	return (
		<Button
			type="button"
			statusCriminal={data.statusCriminal}
			onClick={handleClick}
		/>
	);
};
